import { mobileBreakPoint } from "../effets.prod";

let animEnCours = false;

/**
 * Enlève les effets appliqués sur le menu mobile.
 */
export const resetMenu = () => {
    document.querySelector(".menuSite-bouton")?.classList.remove("active");
    document.querySelector(".menuSite-interne")?.removeAttribute("style");
    if (document.querySelector(".menuSite-interne > ul > li")) {
        document.querySelector(".menuSite-interne > ul > li").style.left = "0";
    }
    document.querySelector(".menuSite-retour")?.remove();

    document.querySelectorAll('.parentLink > ul').forEach(e => e.removeAttribute("style"));
};
/**
 * On enrichit le menu mobile.
 *
 */
export const enrichissementMenu = () => {
    document.querySelectorAll(".menuSite li ul").forEach((element) => {
        // On met la classe parentLink sur les li qui contiennent des sous-ul
        element.closest("li").classList.add("parentLink");
        // On rajoute la petite fleche qui servira pour naviguer dans les niveaux sur mobile
        const span = document.createElement("span");
        span.classList.add("niveauEnfant");
        element.closest("li").querySelector("a").append(span);
    });
};
/**
 * Ouvre le menu mobile au clic.
 *
 * @param {HTMLElement} element
 * @param {string} selector
 */
export const openMenu = (element, selector) => {
    element = element.closest(selector);

    if (element.classList.contains("active")) {
        element.classList.remove("active");
        setTimeout(function () {
            resetMenu();
        }, 100);
    } else {
        element.classList.add("active");
    }
};
/**
 * Permet la navigation dans les sous-menus du menu mobile.
 *
 */
export const navigationMenuMobile = () => {
    document
        .querySelector(".menuSite-interne")
        ?.addEventListener("click", (event) => {
            if (window.innerWidth < mobileBreakPoint) {
                /** @type {HTMLElement} */

                const target = event.target.closest("li").querySelector("ul");
                if (target !== null && !animEnCours) {
                    animEnCours = true;
                    // Création du bouton retour
                    const a = document.createElement("a");
                    a.title =
                        document.querySelector(
                            "#menu-interne"
                        ).dataset.texteTitle;
                    a.href = "#";
                    a.innerText =
                        document.querySelector("#menu-interne").dataset.texte;
                    const li = document.createElement("li");
                    li.classList.add("menuSite-retour");
                    li.append(a);
                    // Ajout du bouton retour au menu
                    target.prepend(li);
                    target.style.display = "block";
                    // jQuery pour l'animation. J'ai abandonné.
                    $(".menuSite-interne")
                        .stop(true, true)
                        .animate({ left: "-=100%" }, 400, function () {
                            animEnCours = false;
                        });
                    // Empêche la navigation
                    event.preventDefault();
                } else {
                    return true;
                }
            }
        });
};
//CLICK FLECHE RETOUR
$(".menuSite ul li").on("click", ".menuSite-retour", function () {
    const retour = $(this);
    if (!animEnCours) {
        animEnCours = true;
        $(".menuSite-interne")
            .stop(true, true)
            .animate({ left: "+=100%" }, 400, function () {
                retour.parent("ul").css("display", "none");
                retour.remove();
                animEnCours = false;
            });
    }
    return false;
});
